<div class="med-card">
  <ng-content></ng-content>
</div>
